//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonRoleService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonRole.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/person-role/create', params || { });
	};

	//GeneratorFlag:[PersonRole.Delete]
	async delete(personRoleId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:personRoleId
		}
	
		return await _server.delete('/hub/person-role/delete', {'params':params})
	};

	//GeneratorFlag:[PersonRole.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-role/detail', {'params':params});
	};

	//GeneratorFlag:[PersonRole.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-role/list', {'params':params});
	};

	//GeneratorFlag:[PersonRole.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/person-role/update', params || { });
	};

//GeneratorFlag:[NewAction]
}